/* NEXT LEVELZ — interaktioner. Ingen biblioteker. Idempotent ved section-reload. */
(function () {
  'use strict';

  var root = document.documentElement;

  function scroller() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 4) return w;
    return null;
  }
  function scrollTop() {
    var s = scroller();
    return s ? s.scrollTop : window.scrollY || root.scrollTop || 0;
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('nlz-scrolled', scrollTop() > 24);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  onScroll();

  function measure(scope) {
    (scope || document)
      .querySelectorAll('svg [data-draw]:not([data-m]), .nlz-src__u path:not([data-m])')
      .forEach(function (p) {
        p.setAttribute('data-m', '1');
        var len = 600;
        try { len = Math.ceil(p.getTotalLength()) + 6; } catch (e) { /* noop */ }
        p.style.setProperty('--len', len);
      });
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.04, rootMargin: '0px 0px -4% 0px' });
  }

  var SEL = '.nlz-rv, .nlz-mask, .nlz-lines, .nlz-cell, .nlz-orn, .nlz-src__intro';

  function reveal() {
    measure(document);
    document.querySelectorAll('.nlz-lines').forEach(function (el) {
      el.querySelectorAll('span').forEach(function (s, i) {
        if (s.firstElementChild) s.firstElementChild.style.setProperty('--i', i);
      });
    });
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.nlzObs) return;
      el.dataset.nlzObs = '1';
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  setTimeout(function () {
    document.querySelectorAll(SEL).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.2 && r.bottom > -200) el.classList.add('is-in');
    });
  }, 2500);

  /* ---- Tom ingrediens-rubrik: reserve for browsere uden :has() ----
     Rubrikken skjules primært med CSS i blocks/nlz-ingredients.liquid:
         accordion-custom:has([data-nlz-ing-empty]) { display: none }
     Den regel dækker stort set alle nuværende browsere og virker uden flimmer.
     Denne reserve kører KUN, hvis browseren ikke forstår :has() — ellers ville
     vi lave arbejde, CSS allerede har gjort. Kravet var, at en tom harmonika
     aldrig må vises; her er det garanteret hele vejen rundt. */
  function hideEmptyAccordions() {
    try {
      if (window.CSS && CSS.supports && CSS.supports('selector(:has(*))')) return;
    } catch (e) { /* ingen CSS.supports — kør reserven */ }
    document.querySelectorAll('[data-nlz-ing-empty]').forEach(function (marker) {
      var row = marker.closest('accordion-custom') || marker.closest('details');
      if (row) row.style.display = 'none';
    });
  }

  /* ---- Mobilmenu: Escape lukker skuffen, og fokus vender tilbage ----
     Horizons menuskuffe er bygget på <details>/<summary>, og et details-element
     lukker ikke af sig selv på Escape. Uden dette er menuen en fælde for
     tastaturbrugere: den kan åbnes, men kun lukkes med musen.

     To detaljer, der begge er lavet med vilje:
     1) Vi lukker ved at klikke på summary, så Horizons egen åbn/luk-logik
        (scroll-lås, animation, aria-expanded) kører præcis som ellers — i
        stedet for at sætte open-attributten direkte og gå uden om den.
     2) preventScroll: true. Menuknappen ligger i den klistrede header, hvis
        layout-position er i toppen af DOKUMENTET. Et almindeligt focus() ville
        derfor rulle siden helt op, når man lukkede menuen — målt: fra 1800px
        til 28px. Med preventScroll bliver man stående præcis samme sted. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var det = document.querySelector('details.menu-drawer-container[open]');
    if (!det) return;
    var sum = det.querySelector('summary.header__icon--menu');
    if (!sum) return;
    e.preventDefault();
    sum.click();
    try { sum.focus({ preventScroll: true }); } catch (err) { /* noop */ }
  });

  /* ---- Bundle / mængdevalg: taler med Horizons egen komponent ---- */
  function quantityComponent(scope) {
    var section = (scope && scope.closest('.shopify-section')) || document;
    return (
      section.querySelector('quantity-selector-component') ||
      document.querySelector('quantity-selector-component')
    );
  }

  function applyQuantity(scope, qty) {
    var comp = quantityComponent(scope);
    if (!comp) return false;
    var input = comp.querySelector('input[name="quantity"]');
    if (!input) return false;

    input.value = String(qty);
    try { if (comp.updateButtonStates) comp.updateButtonStates(); } catch (e) { /* noop */ }
    try { if (comp.onQuantityChange) comp.onQuantityChange(); } catch (e) { /* noop */ }
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function selectTier(tier) {
    var group = tier.closest('[data-nlz-bundle]');
    if (group) {
      group.querySelectorAll('[data-nlz-qty]').forEach(function (t) {
        t.classList.remove('is-on');
        t.setAttribute('aria-checked', 'false');
      });
    }
    tier.classList.add('is-on');
    tier.setAttribute('aria-checked', 'true');
    applyQuantity(tier, tier.getAttribute('data-nlz-qty'));
  }

  document.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-nlz-qty]');
    if (tier) selectTier(tier);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var tier = e.target.closest('[data-nlz-qty]');
    if (!tier) return;
    e.preventDefault();
    tier.click();
  });

  function reapplyTier() {
    var active = document.querySelector('[data-nlz-qty].is-on');
    if (!active) return;
    var qty = active.getAttribute('data-nlz-qty');
    if (qty && qty !== '1') applyQuantity(active, qty);
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker, .variant-picker')) setTimeout(reapplyTier, 350);
  });

  /* ---- Vandrette rails ---- */
  function initRails() {
    document.querySelectorAll('[data-nlz-rail]').forEach(function (rail) {
      if (rail.dataset.nlzRailInit) return;
      rail.dataset.nlzRailInit = '1';

      var track = rail.querySelector('[data-nlz-track]');
      if (!track) return;
      var prev = rail.querySelector('[data-nlz-prev]');
      var next = rail.querySelector('[data-nlz-next]');

      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var scrollable = max > 4;
        rail.classList.toggle('nlz-rail--static', !scrollable);
        if (prev) prev.disabled = !scrollable || track.scrollLeft <= 4;
        if (next) next.disabled = !scrollable || track.scrollLeft >= max - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      setTimeout(update, 400);
    });
  }

  function init() {
    reveal();
    initRails();
    hideEmptyAccordions();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 30); setTimeout(reapplyTier, 150); });
  document.addEventListener('shopify:block:select', function () { setTimeout(init, 30); });
})();
